import { render, staticRenderFns } from "./ClientAddressCarousel.vue?vue&type=template&id=324d74c4&scoped=true"
import script from "./ClientAddressCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientAddressCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClientAddressCarousel.vue?vue&type=style&index=0&id=324d74c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d74c4",
  null
  
)

export default component.exports